import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', path: '/' },
  { label: '发现', path: '/category/all' },
  { label: '设计', path: '/category/design' },
  { label: '摄影', path: '/category/photography' },
  { label: '写作', path: '/category/writing' },
  { label: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 no-underline">
            <span
              className={`text-2xl font-heading font-bold ${
                scrolled || !isHome ? 'text-primary-500' : 'text-background-50'
              }`}
            >
              cy社区
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => {
              const isActive =
                link.path === '/'
                  ? location.pathname === '/'
                  : location.pathname.startsWith(link.path);
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                    isActive
                      ? 'bg-primary-100/80 text-primary-700'
                      : scrolled || !isHome
                        ? 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                        : 'text-background-50/90 hover:text-background-50 hover:bg-background-50/10'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap transition-colors ${
                scrolled || !isHome
                  ? 'text-foreground-600 hover:text-foreground-900'
                  : 'text-background-50/80 hover:text-background-50'
              }`}
            >
              登录
            </Link>
            <Link
              to="/about"
              className={`px-5 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 ${
                scrolled || !isHome
                  ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                  : 'bg-background-50 text-primary-600 hover:bg-background-100'
              }`}
            >
              免费注册
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
              scrolled || !isHome
                ? 'text-foreground-700 hover:bg-background-100'
                : 'text-background-50 hover:bg-background-50/10'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => {
              const isActive =
                link.path === '/'
                  ? location.pathname === '/'
                  : location.pathname.startsWith(link.path);
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-primary-100/80 text-primary-700'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
            <div className="flex gap-3 mt-3 pt-3 border-t border-background-200/70">
              <Link
                to="/about"
                className="flex-1 text-center py-2.5 rounded-lg border border-background-300 text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors whitespace-nowrap"
              >
                登录
              </Link>
              <Link
                to="/about"
                className="flex-1 text-center py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                免费注册
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}